'use client';
import styles from './pick-programs.module.scss';
import {closeOverlay, openOverlay} from 'store/slices/overlay.slices';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {useEffect, useState} from 'react';
import {liveBroadcast} from '../../../../../libs/constants/live-broadcast';
import {getPlayer} from '../../../../../store/slices/player.slices';

export const PickPrograms = () => {
    const [hiddenControlTrack, setHiddenControlTrack] = useState(true);
    const {track} = useAppSelector(getPlayer);
    const {isOpen} = useAppSelector((store) => store.overlay);

    const dispath = useAppDispatch();

    useEffect(() => {
        if (track === liveBroadcast[0].media.audio) {
            setHiddenControlTrack(true);
        } else {
            setHiddenControlTrack(false);
        }
    }, [track]);

    /* Скрывает или показывает меню передач */
    const toggleWindows = () => {
        dispath(isOpen ? closeOverlay() : openOverlay());
    };

    return (
        <button onClick={toggleWindows} className={styles.btn}>
            {/*{!hiddenControlTrack && <IconList />}*/}
        </button>
    );
};
